<template>
  <div
    style="min-width: 1200px"
    class="big"
  >
    <div class="page_title flex_between">
      <span>编辑关联记录</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div style="text-align:left">
          <span class="gray">手机号（业务员）</span>
          <span style="margin-right:50px">{{recommender_phone}}</span>
          <span class="gray">员工号</span>
          <span style="margin-right:50px">{{recommender_code}}</span>
          <span class="gray">员工姓名</span>
          <span>{{recommender_name}}</span>
        </div>
        <div
          class="flex_between"
          style="margin:20px 0 10px"
        >
          <span style="margin-right:40px">已关联用户列表</span>
          <span>
            <el-button
              type="primary"
              @click="updateAll"
              plain
              :disabled="module_id_array[0]?!module_id_array.includes('969'):false"
            >批量换关联</el-button>
            <el-button
              type="primary"
              @click="addDia"
              :disabled="module_id_array[0]?!module_id_array.includes('950'):false"
            >添加关联用户</el-button>
          </span>
        </div>
        <!-- 表格 -->
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1200px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="nick_name"
              label="用户昵称"
            />
            <el-table-column
              prop="phone"
              label="手机号"
            />
            <el-table-column
              label="用户已邀请用户数"
              prop="share_count"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="updateDia(scope.row.user_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('969')
                      : false
                  "
                >换关联</el-button>
                <el-button
                  type="text"
                  @click="unbound(scope.row.user_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('948')
                      : false
                  "
                >解除关联</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="size=>{return sizeChange(size,1)}"
            @current-change="page=>{return pageChange(page,1)}"
            :current-page="table_page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="table_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="table_num"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 换关联业务员 -->
    <el-dialog
      title="换关联业务员"
      :visible.sync="changeUser"
      width="800px"
      style="text-align: left"
      :close-on-click-modal="false"
      @close="closeDia"
      center
    >
      <div style="padding: 20px">
        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">员工姓名</div>
            <el-input
              v-model="recommender_name_m"
              size="small"
              style="width: 100px"
              @change="search(2)"
            />
          </div>
          <div class="box flex">
            <div class="label">员工号</div>
            <el-input
              v-model="recommender_code_m"
              @change="search(2)"
              size="small"
              style="width: 100px"
            />
          </div>
          <div class="box flex">
            <div class="label">手机号</div>
            <el-input
              v-model="phone_m"
              @change="search(2)"
              size="small"
              style="width: 100px"
            />
            <el-button
              type="info"
              class="search-button"
              @click="search(2)"
              size="small"
            >查询</el-button>
          </div>

        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="hbData"
            tooltip-effect="dark"
            style="width: 100%"
            height="450px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column width="55">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.check"
                  @change="(value)=>{return changeRadio(value,scope.row)}"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              prop="recommender_code"
              label="员工号"
            />
            <el-table-column
              prop="recommender_name"
              label="员工姓名"
            />
            <el-table-column
              prop="phone"
              label="手机号"
            />
          </el-table>
        </div>
        <div style="text-align:center;margin:20px 0">
          <el-pagination
            @size-change="size=>{return sizeChange(size,2)}"
            @current-change="page=>{return pageChange(page,2)}"
            :current-page="hb_page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="hb_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="hb_num"
          ></el-pagination>
        </div>
        <div style="text-align:center;0">
          <el-button
            type="primary"
            @click="updateUserBind"
            size="medium"
            style="margin-right:20px"
          >确 定</el-button>
          <el-button
            plain
            size="medium"
            @click="changeUser=false"
          >取 消</el-button>
        </div>
      </div>

    </el-dialog>
    <!-- 添加关联用户弹窗 -->
    <el-dialog
      title="添加关联用户"
      :visible.sync="addDialog"
      width="720px"
      style="text-align: left;"
      :close-on-click-modal="false"
      @close="closeDia"
      center
    >
      <div style="padding: 20px">
        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">手机号(被关联)
            </div>
            <el-input
              v-model="nick_name"
              size="medium"
              style="width: 140px"
              @change="search(3)"
            />
          </div>
          <div class="box flex">
            <div class="label">用户昵称(被关联)</div>
            <el-input
              v-model="phone"
              @change="search(3)"
              size="medium"
              style="width: 140px"
            />
          </div>
          <div class="box flex">
            <div class="label">是否已被关联</div>
            <span>
              <el-radio-group
                v-model="relation_bool"
                @change="search(3)"
              >
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>
            <el-button
              type="info"
              class="search-button"
              @click="search(3)"
              size="small"
            >查询</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="addData"
            tooltip-effect="dark"
            style="width: 100%"
            height="450px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="addSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="nick_name"
              label="用户昵称"
            />
            <el-table-column
              prop="phone"
              label="手机号"
            />
            <el-table-column label="是否已被关联">
              <template slot-scope="scope">
                <span v-if="scope.row.relation_id>0">是</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align:center;margin:20px 0">
          <el-pagination
            @size-change="size=>{return sizeChange(size,3)}"
            @current-change="page=>{return pageChange(page,3)}"
            :current-page="hb_page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="hb_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="add_num"
          ></el-pagination>
        </div>
        <div style="text-align:center;0">
          <el-button
            type="primary"
            @click="addRegisterUser"
            size="medium"
            style="margin-right:20px"
          >确 定</el-button>
          <el-button
            plain
            size="medium"
            @click="addDialog=false"
          >取 消</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      recommender_code: this.$route.query.recommender_code,
      recommender_name: this.$route.query.recommender_name,
      recommender_phone: this.$route.query.recommender_phone,
      table_page: 1, //已绑定用户列表
      table_size: 10, //已绑定用户列表
      table_num: 0, //已绑定用户列表
      tableData: [], //已绑定用户列表
      hb_page: 1, //换关联列表
      hb_size: 10, //换关联列表
      hb_num: 0, //换关联列表
      hbData: [], //换关联列表
      add_page: 1, //新增用户列表
      add_size: 10, //新增用户列表
      add_num: 0, //新增用户列表
      addData: [], //新增用户列表
      info: {},
      login_app: 0,
      staffMsg: false,
      addDocShow: false,
      register_ids: '',
      changeUser: false,
      user_id: '',
      recommender_name_m: '',
      recommender_code_m: '',
      nick_name_m: '',
      phone_m: '',
      addDialog: false,
      phone: '',
      login_app_m: 0,
      nick_name: '',
      relation_bool: '',
      selection: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
    this.getHbList();
    this.getAddList();
  },
  methods: {
    //获取已绑定用户列表
    getList() {
      let data = {
        recommender_code: this.$route.query.recommender_code,
        page: this.table_page,
        pageNumber: this.table_size
      };
      this.axios
        .post('platform/Activity/getRelationUserMoreList', data)
        .then((res) => {
          if (!res.data.list.length && this.table_page > 1) {
            this.table_page = this.table_page - 1;
            this.getList();
          }
          this.table_num = res.data.total;
          this.tableData = res.data.list;
        });
    },
    //获取换关联邀请人列表
    getHbList() {
      let data = {
        recommender_code: this.recommender_code_m,
        recommender_name: this.recommender_name_m,
        not_recommender_code: this.recommender_code,
        recommender_phone: this.phone_m,
        page: this.hb_page,
        pageNumber: this.hb_size
      };
      this.axios
        .post('platform/Activity/getRelationUserList', data)
        .then((res) => {
          this.hb_num = res.data.total;
          this.hbData = res.data.list.map((item) => {
            item.check = false;
            return item;
          });
        });
    },
    //获取添加关联用户列表
    getAddList() {
      let data = {
        recommender_code: this.recommender_code,
        nick_name: this.nick_name,
        phone: this.phone,
        relation_bool: this.relation_bool,
        page: this.add_page,
        pageNumber: this.add_size
      };
      this.axios
        .post('platform/Activity/relationUserList', data)
        .then((res) => {
          this.add_num = res.data.total;
          this.addData = res.data.list;
        });
    },
    search(type) {
      if (type == 1) {
        this.table_page = 1;
        this.getList();
      }
      if (type == 2) {
        this.hb_page = 1;
        this.getHbList();
      }
      if (type == 3) {
        this.add_page = 1;
        this.getAddList();
      }
    },
    //每页数据的条数
    sizeChange(size, type) {
      if (type == 1) {
        //已关联
        this.table_size = size;
        this.getList();
      }
      if (type == 2) {
        //换关联
        this.hb_size = size;
        this.getHbList();
      }
      if (type == 3) {
        //添加
        this.add_size = size;
        this.getAddList();
      }
    },
    //当前第几页
    pageChange(page, type) {
      if (type == 1) {
        //已关联
        this.table_page = page;
        this.getList();
      }
      if (type == 2) {
        //换关联
        this.hb_page = page;
        this.getHbList();
      }
      if (type == 3) {
        //添加
        this.add_page = page;
        this.getAddList();
      }
    },
    //弹窗列表选择修改
    changeRadio(value, row) {
      if (value) {
        this.hbData.forEach((item) => {
          item.check = false;
        });
        row.check = true;
        this.user_id = row.recommender_code;
      } else {
        this.user_id = '';
      }
    },
    //换关联弹窗
    updateDia(user_id) {
      this.register_ids = user_id;
      this.user_id = '';
      this.hbData.forEach((item) => {
        item.check = false;
      });
      this.changeUser = true;
    },
    //多选
    handleSelectionChange(val) {
      let selection = val.map((item) => {
        return item.user_id;
      });
      this.register_ids = selection.toString();
    },
    //批量换关联
    updateAll() {
      if (!this.register_ids) {
        this.$message.error('请选择需要换关联的用户');
        return false;
      }
      this.changeUser = true;
    },
    //换关联
    updateUserBind() {
      if (!this.user_id) {
        this.$message.error('请选择邀请人');
        return false;
      }
      let data = {
        recommender_code: this.user_id,
        relation_ids: this.register_ids
      };
      this.axios
        .post('platform/Activity/changeRelationUserId', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('换关联成功');
            this.changeUser = false;
            this.getList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //解绑
    unbound(register_id) {
      this.$confirm('确定要解除该用户绑定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Activity/unboundRegisterUser', { register_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('解绑成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //添加用户多选
    addSelectionChange(val) {
      this.selection = val;
    },
    //添加用户弹窗
    addDia() {
      this.getAddList();
      this.addDialog = true;
    },
    //添加关联用户
    addRegisterUser() {
      if (!this.selection.length) {
        this.$message.error('请选择用户');
        return false;
      }
      for (let i = 0; i < this.selection.length; i++) {
        if (this.selection[i].share_id > 0) {
          this.$alert(
            '勾选的用户存在已被关联用户，请先解除原关联关系，或者换关联操作！',
            '提示',
            {
              confirmButtonText: '关闭'
            }
          );
          return false;
        }
      }
      let selection = this.selection.map((item) => {
        return item.register_id;
      });
      let data = {
        recommender_code: this.recommender_code,
        relation_user_ids: selection.toString()
      };
      this.axios
        .post('platform/Activity/bindingRelationUser', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('关联成功');
            this.closeDia();
            this.getList();
          }
        });
    },
    closeDia() {
      this.register_ids = '';
      this.selection = [];
      this.changeUser = false;
      this.addDialog = false;
      this.getList();
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  align-items: center;
  .box {
    margin-right: 20px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;

    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
    margin-left: 10px;
  }
}
.gray {
  color: #747981;
  margin-right: 10px;
}
.itemtitle {
  display: inline-block;
  width: 60px;
  text-align: right;
  margin-right: 10px;
}
</style>